var styles = {"fontElementMap":"vDM7w","orderedlist":"_07aOU","bulletedlist":"xJCkI","listItem":"_5Qm0V"};

export { styles as s };
//# sourceMappingURL=lists-82244ba5.js.map
